import { z } from "zod";
import { ResourceVisibilityPayloadSchema } from "~/core/ResourceVisibility";
import { SanityLocalizedFieldSchema } from "~/core/api/Sanity/localize";

export const LogePagesPayloadSchema = z.array(
  z.object({
    seoSlug: z.object({
      current: z.string(),
    }),
    gogaillePlacesAddressDetails: SanityLocalizedFieldSchema,
    gogaillePlacesDistancesDetails: SanityLocalizedFieldSchema,
    gogaillePlacesParkingsDetails: SanityLocalizedFieldSchema,
    accessibility: z.object({
      reducedMobilityRooms: z.boolean(),
      elevator: z.boolean(),
      stairliftPlatform: z.boolean(),
    }),
    visibility: ResourceVisibilityPayloadSchema,
    logo: z
      .object({
        asset: z.object({
          url: z.string().nullable(),
          metadata: z.object({
            dimensions: z.object({
              width: z.number(),
              height: z.number(),
            }),
          }),
        }),
      })
      .nullable()
      .optional(),
    intro: SanityLocalizedFieldSchema.nullable().optional(),
    features: z
      .object({
        garden: z.boolean().nullable(),
        terrace: z.boolean().nullable(),
        bikePark: z.boolean().nullable(),
        carPark: z.boolean().nullable(),
      })
      .nullable()
      .optional(),
    loge: z.object({
      _id: z.string(),
      pmsId: z.object({
        current: z.string(),
      }),
      name: z.string(),
      gallery: z
        .array(
          z.object({
            asset: z.object({
              url: z.string().nullable(),
            }),
            caption: SanityLocalizedFieldSchema.nullable(),
          }),
        )
        .nullable()
        .optional(),
      building: z.object({
        address: z.object({
          line1: z.string(),
          line2: z.string().nullable(),
          postalCode: z.string(),
          city: z.string(),
          coordinate: z.object({
            lat: z.number(),
            lng: z.number(),
          }),
        }),
      }),
    }),
    houseKeeperEditorial: z
      .object({
        photo: z
          .object({
            asset: z.object({
              url: z.string().nullable(),
              metadata: z
                .object({
                  dimensions: z.object({
                    width: z.number(),
                    height: z.number(),
                  }),
                })
                .optional(),
            }),
          })
          .nullable(),
        text: SanityLocalizedFieldSchema.nullable(),
        additionalInformation: SanityLocalizedFieldSchema.nullable(),
      })
      .nullable()
      .optional(),
  }),
);
